import { ChangeDetectionStrategy, Component, computed, ElementRef, input, output, signal, viewChild } from "@angular/core"
import { FormsModule } from "@angular/forms"
import { BvViewFilterOption, FilterOptionsMap } from "./models"

@Component({
  selector: 'checkbox-list',
  template: `
   <div class="max-h-[400px] min-w-[150px] overflow-auto" (click)="$event.stopPropagation()">
        @if (loading()) {
          <div class="px-3 py-2">Loading...</div>
        }
        @if (options(); as options) {
          <div class="p-1">
            <input
              #input
              type="text"
              [placeholder]="selected()"
              class="form-input w-full"
              [ngModel]="search()"
              (ngModelChange)="search.set($event)"
            />
          </div>
          @for (option of filteredOptions(); track option.title) {
            <div class="px-1">
              <label class="px-3 py-2 block cursor-pointer text-sm">
                <input
                  type="checkbox"
                  class="mr-2"
                  [(ngModel)]="option.selected"
                  (ngModelChange)="onFilterChange.emit({ option })"
                />
                {{ option.title }}
              </label>
            </div>
          }
        }
      </div>
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ FormsModule],
})
export class CheckboxListComponent {
  readonly loading = input(false)
  readonly options = input<FilterOptionsMap | undefined>()
  readonly selected = input<string | undefined | null>()
  readonly onFilterChange = output<{ option: BvViewFilterOption }>()
  readonly input = viewChild<ElementRef>('input')

  protected readonly search = signal<string>('')
  protected readonly filteredOptions = computed(() => {
    return this.options()?.[this.selected()]?.filter((o) => o.title.toLowerCase().includes(this.search().toLowerCase()))
  })

  ngAfterViewInit() {
    setTimeout(() => {
      this.input()?.nativeElement.focus()
    }, 0)
  }
}
